import { Pipe, PipeTransform } from '@angular/core';

import { SnUser } from '@lib/api/entities';

@Pipe({
  name: 'snUserFilter',
})
export class SnUserFilterPipe implements PipeTransform {
  public transform(users: SnUser[], value: string): SnUser[] {
    if (!users) {
      return;
    }

    value = value.toLowerCase().trim();

    return users.filter((user) => {
      return user.fullName.toLowerCase().includes(value);
    });
  }
}
